import React from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import CountUp from "@/components/CountUp";

export default function AboutPage() {
  return (
    <section className="entity page-pad">
      <div className="wrap">
        <Reveal as="p" className="eyebrow">
          About
        </Reveal>
        <Reveal as="h1" className="page-title" style={{ maxWidth: "16ch" }} delay={70}>
          Bridge market need and new technology — then ship it.
        </Reveal>
        <Reveal as="p" className="entity__lead" delay={140}>
          IT-Patrol is a development and consulting practice focused on Ecommerce, SaaS, and AI. We work underneath your
          existing tools — DMS, CRM, commerce platforms — hardening what you already run and extending it with systems
          that stay operable after handoff.
        </Reveal>

        <Reveal className="page-metrics page-metrics--on-dark" delay={180}>
          <div className="page-metric">
            <strong>
              <CountUp to={3} />
            </strong>
            <span>Core practices</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={2} />
            </strong>
            <span>Live Shopify apps</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={12} suffix="+" />
            </strong>
            <span>Years in software</span>
          </div>
        </Reveal>

        <div className="entity__facts" style={{ marginTop: "2.5rem" }}>
          <Reveal className="entity__fact" delay={100}>
            <h2 style={{ fontSize: "1.1rem" }}>Entity</h2>
            <p>
              IT-Patrol — development &amp; consulting. Based in Sfax, Tunisia. Serving merchants and product teams
              worldwide.
            </p>
          </Reveal>
          <Reveal className="entity__fact" delay={180}>
            <h2 style={{ fontSize: "1.1rem" }}>Products</h2>
            <p>
              Live Shopify apps including{" "}
              <Link to="/apps/cart-reservation-patrol" style={{ textDecoration: "underline" }}>
                Cart Reservation Patrol
              </Link>
              ,{" "}
              <Link to="/apps/ai-sales-patrol" style={{ textDecoration: "underline" }}>
                AI Sales Patrol
              </Link>
              , and{" "}
              <Link to="/apps/eu-compliance-patrol" style={{ textDecoration: "underline" }}>
                EU Compliance Patrol
              </Link>
              .
            </p>
          </Reveal>
          <Reveal className="entity__fact" delay={260}>
            <h2 style={{ fontSize: "1.1rem" }}>Contact</h2>
            <p>
              <Link to="/contact" style={{ textDecoration: "underline" }}>
                Start a project
              </Link>{" "}
              or email businessandadministration@it-patrol.tech.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
